import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeviceListSettings } from 'src/app/models/deviceSettings.model';
import { DeviceModel } from 'src/app/models/device.model';
import { State } from 'src/app/models/contract/list-item.model';
import * as _ from 'lodash';
import { GroupBy, LastDataModel, Medicion } from '../../device-datos/device-datos.component';
import { BehaviorSubject, combineLatest, from, Observable, of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { DispositivoService } from 'src/app/services/dispositivo/dispositivo.service';
import { GeoDevicesService, LastDataDevice } from 'src/app/services/mapa/geodevices.service';
import { map, mergeAll, mergeMap, take, tap, toArray, } from 'rxjs/operators';
import { GetDatePipe } from 'src/app/pipes/pipes/pipe-date.pipe';
import moment from 'moment-timezone';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-device-last-stats-list',
  templateUrl: './device-last-stats-list.component.html',
  styleUrls: ['./device-last-stats-list.component.scss'],
  providers: [
    GetDatePipe
],
})
export class DeviceLastStatsListComponent implements OnInit {

  @Input() allDevicesWithChildren: DeviceModel[];
  @Input() title: string;
  @Input() deviceChildrenList: DeviceModel[];
  @Input() loadingChildren: boolean;
  @Input() parentDeviceId: string;
  @Input() selectedLanguage: string;
  deviceSettings: DeviceListSettings =
    {
      titleType: 'factory',
      actionIcon: 'circle-right',
      selectable: State.selected
    }

    obileMode = false;
    loading = false;
    loadingText = 'Loading '
    entities$: Observable<LastDataModel[]>;
    filteredEntities$: Observable<LastDataModel[]>;
  
    deviceFilter$ = new BehaviorSubject<string>(null);
    filter: FormControl;

  public itemObservable: DeviceModel[];
  public allItemObservable: DeviceModel[];
  @Output() deviceItemNavegate: EventEmitter<DeviceModel> = new EventEmitter<DeviceModel>();

  constructor(
    private dispositivoService: DispositivoService,
    private geoDevicesService: GeoDevicesService,
    private getDatePipe: GetDatePipe,
    private loginService: LoginService,
  ) { }

  ngOnInit() {
    this.itemObservable = _.sortBy(this.deviceChildrenList, ['name'], ['asc']);
    this.allItemObservable = _.sortBy(this.allDevicesWithChildren, ['name'], ['asc']);

    this.filter = new FormControl('');
    
  }

  ngOnChanges(changes: any): void {
    if (changes.selectedLanguage) {
      this.loadDevices(changes.selectedLanguage.currentValue);
      this.getFilteredDevices(changes.selectedLanguage.currentValue);
      this.loadingChildren = false;
    }

    if (changes.deviceChildrenList !== undefined) {
      this.itemObservable = changes.deviceChildrenList.currentValue;
     

    } else {
      if (changes.loadingChildren !== undefined) {
      }
    }
    if (changes.parentDeviceId !== undefined){
      this.loadDevices(changes.selectedLanguage.currentValue);
      this.getFilteredDevices(changes.selectedLanguage.currentValue);
      this.loadingChildren = false;
    }
    
  }

  public navigate(item: DeviceModel) {
    this.deviceItemNavegate.emit(item);
  }


  
  loadDevices(language: string){
    this.entities$ = this.getDevicesNew(language);
  }

  devicesToShow: string[]=[];

  getChildren(devices:DeviceModel[]){
    devices.forEach(device=>{
      this.devicesToShow.push(device.uuid);
      if(device.children.length > 0){
        let children = device.children.map(child=> _.filter(this.allDevicesWithChildren, {uuid: child.uuid})[0])
        this.getChildren(children)
      }else{
        return;
      }
    })
  }

  getDevicesNew(language: string): Observable<LastDataModel[]>{
    return this.geoDevicesService.findLastMeasuresWithDescendancy(this.parentDeviceId).pipe(
      map(res =>{
        return res.filter(device=> device.tiene.length > 0)
        .map(device=> {
          let lastDataMapped: LastDataModel = {
            uuid: device.uuid,
            nombreDispositivo: device.nombre,
            mediciones: _.flattenDeep(device.tiene.map(tiene=> {
                let dato: Medicion;
                let lastFecha
                const timezone = this.loginService.currentUserValue.timeZone
                if (!_.isNil(tiene.lastFecha)){
                  lastFecha = moment.unix(Number(tiene.lastFecha) / Math.pow(10,9)).tz(timezone).format('YYYY-MM-DD HH:mm:ss');
                }
                dato = {nombre: '',
                  stats_last: !_.isNil(tiene.lastValor)?  Number(tiene.lastValor) : null,
                  lastFecha: !_.isNil(tiene.lastFecha)?  lastFecha  : null,
                  codigo: !_.isNil(tiene.es.agrupacion[0]) ? tiene.es.agrupacion[0].nombre : '',
                  unidad: tiene.es.unidad,
                  nombreCode: !_.isNil(tiene.es.agrupacion[0]) ? tiene.es.agrupacion[0].nombre_es : '',
                  descripcion: tiene.es.descripcion,
                }
                switch (language) {
                  case 'en':
                    dato.nombre = tiene.es.nombre_en;
                    break;
                  case 'es':
                    dato.nombre = tiene.es.nombre_es;
                    break;
                  default:
                    dato.nombre = tiene.es.nombre;
                }
                return dato
            })).filter(dato => dato.codigo!=='record' && dato.codigo!=='otros'),
            medicionesAgrupadas: '',
            medicionesTable: [],
            children: []
          }
          return lastDataMapped;
        })
      }),
      // tap (res => console.log ('mapped', res)),
      map(res=> {
        return res.map(device=>{
          device.medicionesAgrupadas = _.groupBy(device.mediciones , group  => group.codigo)
          let record: (Medicion|GroupBy)[] = [];
          Object.entries(device.medicionesAgrupadas).forEach(entry=>{
            let groupBy: GroupBy = {
              codigo: (entry[0]),
              isGroupBy: true
            }
            record.push(...device.medicionesAgrupadas[entry[0]]);
          });

          device.medicionesTable = record;
          return device;
        })
      }),
      map(res=> {
        return _.sortBy(res,'nombreDispositivo')
        .filter(dispositivo=> dispositivo.medicionesTable.length > 0)
      }),
    )
  }

  applyFilter(){
    this.deviceFilter$.next(this.filter.value); 
  }

  getFilteredDevices(language: string){
    this.entities$ = this.getDevicesNew(language);
    this.filteredEntities$ = combineLatest([
      this.entities$,
      this.deviceFilter$
     ]).pipe(
      map(([entities, deviceFilter]) => {
        if (!deviceFilter) { 
            return entities;
         }
         
        return entities.filter(r => r.nombreDispositivo.toLowerCase().includes(deviceFilter.toLowerCase()) );
      })
    );
  }

  public hasChildren(collectionToCheck: Array<any>): boolean {
    return !(collectionToCheck === null || collectionToCheck === undefined || collectionToCheck.length === 0);
  }

  ngOnDestroy() {
   
  }

}
